export interface IVoucherBase {
    VoucherType: VoucherTypesEnum;
    DiscountValue: number;
    MinOrderPrice: number;
    StartDate: Date;
    EndDate: Date;
    VoucherCode: string;
    RestrictedCategoriesIDs: number[];
}

export enum VoucherTypesEnum {
    FixedAmount = 1,
    FreeDelivery,
    Percent
}

export interface IVouchersList {
    Items: IVoucherItem[];
    Total: number;
}

export interface IVoucherItem extends IVoucherBase {
    VoucherID: number;
    Status: VoucherStatusEnum;
    IsExpired?: boolean;
}

export enum VoucherStatusEnum {
    Draft = 1, Published
}

export interface IVoucherFilter {
    limit: number;
    offset: number;
}

export interface IVoucherUpdate {
    VoucherID: number;
}

export interface IVoucherEdit extends IVoucherUpdate, IVoucherBase { }

export interface IExcludedCategory {
    ID: number;
    Name: string;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/vouchers/models/models.ts